<template>
  <v-container fluid>
    <v-card class="elevation-10">
      <v-skeleton-loader
        :loading="loading"
        type="table-heading, table-thead, table-row-divider@12, table-tfoot"
      >
        <v-card-actions>
          <v-row>
            <v-col
              cols="4"
              md="3"
              xl="4"
            >
              <v-toolbar
                flat
              >
                <v-toolbar-title class="md-4  white--text">
                  Fund Bucket Has Types
                </v-toolbar-title>
              </v-toolbar>
            </v-col>
            <v-col
              cols="4"
              md="3"
              xl="4"
            >
              <v-text-field
                v-model="search"
                placeholder="Search"
                append-icon="fa fa-search"
                label="Search Fund Bucket Item Has Type"
                hide-no-data
                hide-selected
                clearable
              />
            </v-col>
            <v-col
              cols="2"
              md="3"
              xl="2"
            />
            <v-col
              cols="2"
              md="3"
              xl="2"
              class="mt-2 text-right"
            >
              <bucket-fund-bucket-has-type-dialog-create
                @created="loadData"
              />
            </v-col>
          </v-row>
        </v-card-actions>

        <v-data-table
          dense
          :headers="headers"
          :items="fundBucketHasTypes"
          :items-per-page="15"
          sort-by="schema_name"
          class="scrollable-table elevation-10"
          :search="search"
        >
          <template v-slot:[`item.schema_name`]="{ item }">
            <div>
              <span>
                {{ item.schema_name }}
              </span>
            </div>
          </template>

          <template v-slot:[`item.fund_bucket`]="{ item }">
            <div>
              <span>
                {{ item.name }}
              </span>
            </div>
          </template>

          <template v-slot:[`item.fund_bucket_type`]="{ item }">
            {{ item }}
            <div>
              <span>
                {{ item.name }}
              </span>
            </div>
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <bucket-fund-bucket-has-type-dialog-edit
              :fund-bucket-has-type="item"
              @updated="loadData"
            />
            <span class="mx-1" />
            <bucket-fund-bucket-has-type-dialog-delete
              :fund-bucket-has-type="item"
              @deleted="loadData"
            />
          </template>
        </v-data-table>
      </v-skeleton-loader>
    </v-card>
  </v-container>
</template>

<script>
  export default {

    data () {
      return {
        loading: true,
        search: '',
        dialog: false,
        snack: '',
        snackColor: '',
        snackText: '',
        headers: [
          { text: 'Schema Name', value: 'schema_name' },
          { text: 'Bucket', value: 'fund_bucket.name' },
          { text: 'Type', value: 'fund_bucket_type.name' },
          { text: 'Actions', value: 'action', align: 'center', class: 'md-2', sortable: false },
        ],
        fundBucketHasTypes: [],
    
        editedItem: {
          name: '',
          identifier: '',
        },
        defaultItem: {
          name: '',
          identifier: '',
        },
      }
    },

    created () {
      this.loadData()
    },

    methods: {
      loadData () {
        this.$api.fundBucketHasTypes().list()
          .then(response => {
            this.fundBucketHasTypes = response.data
            this.loading = false
          })
          .catch(err => {
            console.log(err)
          })
      },
    },
  }
</script>

<style scoped>
    .center-snackbar .v-snack__wrapper .v-snack__content{
        margin:auto !important;
        width:unset !important;
    }
</style>
